import script from "./rightPie.vue?vue&type=script&setup=true&lang=js"
export * from "./rightPie.vue?vue&type=script&setup=true&lang=js"

import "./rightPie.vue?vue&type=style&index=0&id=d85e1cd2&scoped=true&lang=css"
script.__scopeId = "data-v-d85e1cd2"

export default script